<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
		<b-card>
			<b-row>
				<b-col cols="12">
					<app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
				</b-col>
			</b-row>
			<b-row v-if="isUploadSuccess">
				<b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							<b-tab title="Scheduler Configuration" active>
								<b-row class="mb-2">
									<b-col>
										<span class="float-right">
											<b-form-select v-model="schedulerConfigurationPageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
										</span>
									</b-col>
								</b-row>
								<b-row>
								<b-col>
								<div class="table-corner">
									<b-table id="my-table" stacked="md" head-variant="head-light" :no-local-sorting="true" :items="schedulerConfigurations" :fields="fieldsSchedulerConfiguration" :busy="isDataLoading" :sort-by.sync="sortBySchedulerConfiguration" :sort-desc.sync="sortDescSchedulerConfiguration" small responsive>
									<template v-slot:head(actions)>
										<b-button @click="isShowSchedulerConfigurationFilter = !isShowSchedulerConfigurationFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
									</template>
									<template #top-row v-if="isShowSchedulerConfigurationFilter">
										<b-th></b-th>
										<b-th stacked-heading="Interval Type">
											<v-select append-to-body label="name" :options="schedulerCronIntervals" :value="filterSchedulerConfiguration.intervalTypeId"  :reduce="item => item.id" v-model="filterSchedulerConfiguration.intervalTypeId" @search="getSchedulerCronIntervals" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Interval Value">
											<b-form-input id="input-interval-value-table" v-model="filterSchedulerConfiguration.intervalValue" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Interval Value 2">
											<b-form-input id="input-interval-value2-table" v-model="filterSchedulerConfiguration.intervalValue2" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Interval Value 3">
											<b-form-input id="input-interval-value3-table" v-model="filterSchedulerConfiguration.intervalValue3" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Cron Expression">
											<b-form-input id="input-cron-expression-table" v-model="filterSchedulerConfiguration.cronExpression" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Job Type">
											<v-select append-to-body label="jobName" :options="jobConfigurations" :value="filterSchedulerConfiguration.jobTypeId"  :reduce="item => item.id" v-model="filterSchedulerConfiguration.jobTypeId" @search="getJobConfigurations" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Recurring Job Id">
											<b-form-input id="input-recurring-job-id-table" v-model="filterSchedulerConfiguration.recurringJobId" size="sm"></b-form-input>
										</b-th>
										<b-th>
										</b-th>
									</template>
									<template v-slot:table-busys>
										<div class="text-center my-2">
									<b-spinner class="align-middle text-primary"></b-spinner>
										<strong class="ml-2">Loading..</strong>
										</div>
									</template>
									<template v-slot:cell(no)="row">
										{{ ((row.index + 1) + ( schedulerConfigurationPageSize * (currentSchedulerConfigurationPage - 1))) }}
									</template>
									<template v-slot:cell(intervalType)="row">
										{{ row.item.intervalType != null ? row.item.intervalType.name : "" }}
									</template>
									<template v-slot:cell(jobType)="row">
										{{ row.item.jobType != null ? row.item.jobType.jobName : "" }}
									</template>
									</b-table>
									</div>
								</b-col>
								<b-col cols="12">
									<b-pagination
									class="float-right btn-paging"
									v-model="currentSchedulerConfigurationPage"
									:total-rows="totalSchedulerConfigurationRow"
									:per-page="schedulerConfigurationPageSize"
									aria-controls="my-table"
									></b-pagination>
								</b-col>
								</b-row>
							</b-tab>
						</b-tabs>
					</b-card>
				</b-col>
			</b-row>
		</b-card>
		<template #modal-footer="{ ok, cancel }">
			<b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
				Download Error Message
			</b-button>
			<b-button size="sm" variant="success" class="float-right" @click="ok()">
				{{ okTitle }}
			</b-button>
			<b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
				Cancel
			</b-button>
		</template>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</b-modal>
</template>
<style lang="scss" scoped>
.card {
	border: 1px solid rgba(0, 0, 0, 0.125) !important;
}
::v-deep.th-message {
	color: red;
}
::v-deep.modal-footer {
	display: block;
}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate"; 
import { required, minLength } from "vuelidate/lib/validators"; 
import { saveAs } from 'file-saver';

import SchedulerConfiguration from '@/models/SchedulerConfiguration/SchedulerConfiguration';
import SchedulerConfigurationList from '@/models/SchedulerConfiguration/SchedulerConfigurationList';
import SchedulerConfigurationFilter from '@/filters/SchedulerConfiguration/SchedulerConfigurationFilter';

import SchedulerCronInterval from '@/models/SchedulerCronInterval/SchedulerCronInterval';
import SchedulerCronIntervalFilter from '@/filters/SchedulerCronInterval/SchedulerCronIntervalFilter';
import JobConfiguration from '@/models/JobConfiguration/JobConfiguration';
import JobConfigurationFilter from '@/filters/JobConfiguration/JobConfigurationFilter';
import AppInputFileupload from '@/components/AppInputFileupload';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,AppInputDatetimepicker,AppInputDatetimepickerRange,},
	data() {
		return {
			fileupload: null,
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fieldsSchedulerConfiguration: [
				{"no" : { "class" : "th-number"}}, 
				{"intervalType": { "class" : "th-interval-type", "label" : "Interval Type"}, key: 'intervalType', sortable: true}, 
				{"intervalValue": { "class" : "th-interval-value", "label" : "Interval Value"}, key: 'intervalValue', sortable: true}, 
				{"intervalValue2": { "class" : "th-interval-value2", "label" : "Interval Value 2"}, key: 'intervalValue2', sortable: true}, 
				{"intervalValue3": { "class" : "th-interval-value3", "label" : "Interval Value 3"}, key: 'intervalValue3', sortable: true}, 
				{"cronExpression": { "class" : "th-cron-expression", "label" : "Cron Expression"}, key: 'cronExpression', sortable: true}, 
				{"jobType": { "class" : "th-job-type", "label" : "Job Type"}, key: 'jobType', sortable: true}, 
				{"recurringJobId": { "class" : "th-recurring-job-id", "label" : "Recurring Job Id"}, key: 'recurringJobId', sortable: true}, 
				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: true},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessage', sortable: true},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			busy:false,
			isDataLoading: false,
			isBusy : false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			schedulerConfigurations : [],
			schedulerConfigurationId : '',
			totalSchedulerConfigurationRow : 0,
			isShowSchedulerConfigurationFilter: false,
			filterSchedulerConfiguration : null,
			currentSchedulerConfigurationPage : 1,
			schedulerConfigurationPageSize: 10,
			sortBySchedulerConfiguration: '',
			sortDescSchedulerConfiguration: '',
			schedulerCronIntervals: [],
			jobConfigurations: [],
			processId: "",
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post(process.env.VUE_APP_API_URL + 'schedulerconfiguration/confirmUpload',
					[],
					).then(async function(response){
						if (response != null) {
						if (response.data != null) {
							_this.resetModal();
							_this.datas = Array();
							_this.fileupload = null;
							_this.isUploadSuccess = false;
						}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
				let data = new FormData();
				data.append('file', this.fileupload);
				let _this = this;
				this.$http.post(process.env.VUE_APP_API_URL + 'schedulerconfiguration/upload',
					data,
					{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.isBusy = false;
						_this.isUploadSuccess = true;
						_this.getSchedulerConfigurations();
						data = new FormData(); _this.fileupload = null;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
						data = new FormData(); _this.fileupload = null;
					});
				}
			}
		},
		getSchedulerConfigurations : async function() {
			let filter = {};
			Object.assign(filter, this.filterSchedulerConfiguration);
			filter.draftFromUpload = "1";
			filter.draftMode = "1";
			this.sortingBySchedulerConfiguration = Array();
			if (this.sortBySchedulerConfiguration != null) {
				this.sortingBySchedulerConfiguration[this.sortBySchedulerConfiguration] = this.sortDescSchedulerConfiguration;
			}
			let currentPage = (this.currentSchedulerConfigurationPage - 1);
			SchedulerConfiguration.getList(this, filter, this.sortingBySchedulerConfiguration, currentPage , this.schedulerConfigurationPageSize).then(result => {
				this.schedulerConfigurations = result.data;
				this.totalSchedulerConfigurationRow = result.dataCount;
			}).catch(error => {});
		},
		getSchedulerCronIntervals : async function(input) {
			let filter = new SchedulerCronIntervalFilter();
			if (input != undefined) {
				filter.name = input;
			}
			SchedulerCronInterval.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.schedulerCronIntervals = result.data
				}
			})
			.catch(error => {});
		},
		getJobConfigurations : async function(input) {
			let filter = new JobConfigurationFilter();
			if (input != undefined) {
				filter.jobName = input;
			}
			JobConfiguration.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.jobConfigurations = result.data
				}
			})
			.catch(error => {});
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
		downloadLog() {
			let _this = this;
			this.$http.post(process.env.VUE_APP_API_URL + 'schedulerconfiguration/downloadlog', [],
			{ headers: { 'Content-Type': 'application/json' }}
			).then(async function(response){
				await saveAs(process.env.VUE_APP_API_URL + 'schedulerconfiguration/downloadlog', "SchedulerConfiguration.xslx");
				_this.isBusy = false;
			})
			.catch(error => {
				_this.$store.dispatch('addErrorMessageGlobal', error);
				_this.isBusy = false;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		sortBySchedulerConfiguration : {
			handler: function() {
				this.getSchedulerConfigurations();
			}
		},
		sortDescSchedulerConfiguration: {
			handler: function() {
				this.getSchedulerConfigurations();
			}
		},
		currentSchedulerConfigurationPage: {
			handler: function() {
				this.getSchedulerConfigurations();
			}
		},
		schedulerConfigurationPageSize : {
			handler: function() {
				this.getSchedulerConfigurations();
			}
		},
		filterSchedulerConfiguration: {
			handler: function() {
				this.getSchedulerConfigurations();
			},
			deep: true,
		},
		fileupload(newValue, oldValue) {
			if (newValue) {
				this.datas = Array();
				this.isUploadSuccess = false;
			}
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Proses";
				}
				return "Simpan";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterSchedulerConfiguration = new SchedulerConfigurationFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
